import React from 'react';

import Button from '@pb/kit-component-button';
import {Dialog, DialogFooter, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';


type Props = {
    onClose: () => void,
    onRemoveNote: () => void,
    busy: boolean,
};

export const RemoveNoteModal = ({onClose, busy, onRemoveNote}: Props) => (
    <Dialog
        shown={true}
        wrapperProps={{style: {width: 521}}}
        setShown={value => {
            if (!value) {
                onClose();
            }
        }}>
        <DialogHeader onClose={onClose}>
            Remove Release Note
        </DialogHeader>
        <DialogMain style={{padding: 24}}>
            Are you sure you want to remove Release Note?
        </DialogMain>
        <DialogFooter>
            <Group>
                <Button busy={busy} variant="Type.PRIMARY" onClick={onRemoveNote}>
                    Remove
                </Button>
                <Button variant="Type.SECONDARY" onClick={onClose}>
                    Cancel
                </Button>
            </Group>
        </DialogFooter>
    </Dialog>
);
